module.exports = __webpack_public_path__ + "img/BA 4.dfb53a76.png";